<template>
<router-view />
</template>
  
<script setup>
</script>

<style>
html,
body {
    --app-font-family: "Yuanti SC", "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", "Avenir Next", "Segoe UI", "Helvetica Neue", sans-serif;
    --app-color-brand: #92aca0;
    --app-color-primary: #527b7d;
    --app-color-primary-dark: #3f6265;
    --app-color-primary-soft: #eef4f3;
    --app-color-text: #263330;
    --app-color-muted: #6b7280;
    --app-color-border: #dce1df;
    --app-color-surface: #ffffff;
    --app-color-page: #f5f6f5;
    --app-color-page-gradient: linear-gradient(135deg, #f7f8f7 0%, #f7f5f2 58%, #f4f6f6 100%);
    --app-section-background: #f3f6f6;
    --app-section-border: #d8e1e0;
    --app-section-title: #2d3b39;
    --el-font-family: var(--app-font-family);
    --el-color-primary: var(--app-color-primary);
    --el-color-primary-light-3: #7d9c9e;
    --el-color-primary-light-5: #a8bdbf;
    --el-color-primary-light-7: #cbd8d8;
    --el-color-primary-light-8: #dce5e5;
    --el-color-primary-light-9: var(--app-color-primary-soft);
    --el-color-primary-dark-2: var(--app-color-primary-dark);
    margin: 0;
    padding: 0 !important;
    font-family: var(--app-font-family);
    font-size: 12px;
    /* background: linear-gradient(to bottom, #92ACA0, #FFFFFF); */
}

button,
input,
select,
textarea {
    font-family: inherit;
}

#app,
#app *,
.el-popper,
.el-popper * {
    font-family: var(--app-font-family);
}

.el-popper.is-dark[role="tooltip"] {
    pointer-events: none;
}

.required-field .el-input__wrapper,
.required-field .el-select__wrapper,
.required-field .el-textarea__inner {
    border-left: 3px solid #f56c6c;
}

.required-field .el-input-number {
    position: relative;
}

.required-field .el-input-number .el-input__wrapper {
    border-left: 0;
}

.required-field .el-input-number::before {
    position: absolute;
    z-index: 3;
    top: 0;
    bottom: 0;
    left: 0;
    width: 3px;
    border-radius: 4px 0 0 4px;
    background: #f56c6c;
    content: "";
    pointer-events: none;
}

.layout {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: var(--app-color-page);
    border-radius: 3px;
}

.el-header {
    --el-header-padding: 0px !important;
    --el-header-height: 66px !important;
    line-height: 66px;
    flex-shrink: 0;
    background-color: #FFFFFF !important;
}

.logo-container, .header-right {
    line-height: 66px;
    vertical-align: middle;
    padding: 0px 20px;
}

.logo-container img, .header-right img {
    line-height: 66px;
    vertical-align: middle;
}

.el-main {
    /* 让 main 占据剩余空间 */
    flex-grow: 1;
    overflow-y: auto;
    background: var(--app-color-page-gradient);
    padding: 8px !important;
}

.el-footer {
    --el-footer-height: 45px !important;
    display: flex;
    margin-top: auto;
    align-items: center;
    justify-content: center;
    background-color: var(--app-color-brand);
    color: white;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
</style>
